import { Language } from '../../types/language'

export type ContactCopy = {
  heading: string
  subtext: string
  cta: string
}

export type FooterCopy = {
  copyright: string
  kvk: string
  vat: string
  email: string
  privacy: string
}

export const contactCopy: Record<Language, ContactCopy> = {
  nl: {
    heading: 'Klaar voor jouw volgende hoofdstuk?',
    subtext: 'Laten we kennismaken. Elk bericht is vertrouwelijk.',
    cta: 'Plan een kennismaking',
  },
  en: {
    heading: 'Ready to Begin Your Next Chapter?',
    subtext: "Let's connect. Every message is confidential.",
    cta: 'Book a Free Discovery Call',
  },
}

export const footerCopy: Record<Language, FooterCopy> = {
  nl: {
    copyright: '© 2026 MarkV Coaching',
    kvk: 'KvK 42124404',
    vat: 'Btw-id NL005517287B51',
    email: 'info@markvcoaching.com',
    privacy: 'Privacybeleid',
  },
  en: {
    copyright: '© 2026 MarkV Coaching',
    kvk: 'KvK 42124404',
    vat: 'VAT ID NL005517287B51',
    email: 'info@markvcoaching.com',
    privacy: 'Privacy Policy',
  },
}
